export default "__VITE_ASSET__UUtBu8eL__"